import React from 'react'
import { View, StyleSheet, Image } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  logoHeader: {
      display: 'block',
      width: '18%',
  },
});

const Header = () => {
  return (
    <View
      style={{
        backgroundColor: '#ffffff',
        paddingLeft: '5%',
        paddingRight: '5%',
        paddingTop: 7,
        paddingBottom: 7,
      }}
    >
      <Image src={`${process.env.PUBLIC_URL}/logo.png`} style={styles.logoHeader} />
    </View>
  )
}

export default Header